import React from 'react'
import BreadCrumb from '../../components/Global/Breadcrumb/BreadCrumb'
import ContactForm from './ContactForm'

function Contact() {
  
  return (
    <>
      
      <ContactForm />
    </>
  )
}

export default Contact
